import { appAxios } from "@/core/utils/appAxios";
import { routerModel } from "@/router/router.model";
import { APIResponse, SessionDto, UserDto } from "@/shared/api-contract/api-contract";
import jwt_decode from "jwt-decode";
import { computed, shallowRef, watchEffect } from "vue";

export async function useLogin(email: string, password: string) {
    sessionStorage.clear();

    const apiResponse = await appAxios.value.post<APIResponse<SessionDto>>(
        `/client/web/auth/login`,
        {
            email: email,
            password: password,
        },
        {
            headers: {
                "x-request-id": "mk-session",
            },
        },
    );

    if (apiResponse.status !== 200 || apiResponse.data.status.code !== 200) {
        if (apiResponse.data.status.code === 403) {
            return undefined;
        }

        if (apiResponse.data.status.code === 409) {
            routerModel.router.push("/signup/thanks");
        }
    } else {
        return apiResponse.data;
    }
}
